import { useEffect, useState } from 'react';
import Particles, { initParticlesEngine } from '@tsparticles/react';
import { loadFull } from 'tsparticles';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ISourceOptions } from '@tsparticles/engine';
import './App.css';
import particlesOptions from './particles.json';
import Contact from './components/SubscriptionForm';
import StartButton from './components/StartButton';
import Wheel from './components/Wheel';
import { CountdownProvider } from './context/CountdownContext';
import { DataContextProvider } from './context/DataContext';
import { AppConfigProvider, useAppConfig } from './context/AppConfigContext';
import { UserProvider } from './context/UserProvider';
import { toCssLength } from './config';

const AppHeader: React.FC = () => {
  const { config } = useAppConfig();
  const logoSrc = config.logoUrl?.trim() || '';
  const logoStyle = {
    width: toCssLength(config.logoWidth, 'auto'),
    height: toCssLength(config.logoHeight, '40px'),
    objectFit: 'contain' as const,
  };

  return (
    <div className="absolute top-0 left-0 mt-4 ml-6 z-10">
      {logoSrc ? (
        <img src={logoSrc} style={logoStyle} alt={config.brandName || 'Logo'} />
      ) : (
        <span className="text-white text-lg font-semibold">{config.brandName || 'Logo'}</span>
      )}
    </div>
  );
};

function App() {
  const [init, setInit] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadFull(engine);
    }).then(() => setInit(true));
  }, []);

  return (
    <AppConfigProvider>
      <UserProvider>
        <CountdownProvider>
          <DataContextProvider>
            <Router>
              <div className="App">
                <AppHeader />
                {init && <Particles options={particlesOptions as ISourceOptions} />}
                <Routes>
                  <Route path="/" element={<StartButton />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/wheel-of-fortune" element={<Wheel />} />
                </Routes>
              </div>
            </Router>
          </DataContextProvider>
        </CountdownProvider>
      </UserProvider>
    </AppConfigProvider>
  );
}

export default App;
